module.exports = __webpack_public_path__ + "static/media/ysllibre.c002d704.png";